(() => {
  const W = JSON.parse(document.querySelector('[data-anya-runtime]')?.textContent || '{}');
  const builders = document.querySelectorAll('[data-pack-builder]');

  builders.forEach((builder) => {
    const offerButtons = [...builder.querySelectorAll('[data-offer]')];
    const selectorContainer = builder.querySelector('[data-scent-selectors]');
    const selectedOfferHeading = builder.querySelector('[data-selected-offer]');
    const productPrice = builder.querySelector('[data-product-price]');
    const shippingEl = builder.querySelector('[data-pack-shipping]');
    const totalPrice = builder.querySelector('[data-total-price]');
    const priceGrid = builder.querySelector('.anya-composer__price');
    const beforeLabel = builder.querySelector('[data-before-label]');
    const beforeVal = builder.querySelector('[data-before-price]');
    const savingsRow = builder.querySelector('[data-savings-row]');
    const savingsEl = builder.querySelector('[data-savings]');
    const giftLabel = builder.querySelector('[data-gift-label]');
    const giftVal = builder.querySelector('[data-gift-value]');
    const productsLabel = builder.querySelector('[data-products-label]');
    const submitButton = builder.querySelector('[data-whatsapp-submit]');
    const status = builder.querySelector('[data-status]');
    const cityInput = builder.querySelector('[data-pack-city]');
    const promoInput = builder.querySelector('[data-pack-promo]');
    const composer = builder.querySelector('.anya-composer');
    const currency = builder.dataset.currency || 'DH';
    let shippingRate = null;
    let selectedPrice = 0;
    const defaultScent = builder.dataset.defaultScent;
    const scents = [...builder.querySelectorAll('[data-scent]')]
      .filter((item) => item.dataset.available === 'true')
      .map((item) => ({ name: item.dataset.name, label: item.dataset.label || item.dataset.name, color: item.dataset.color }));

    let selectedOffer = offerButtons.find((button) => button.classList.contains('is-selected')) || offerButtons[0];
    const PT = (() => { try { return JSON.parse(builder.querySelector('[data-anya-packjs]')?.textContent || '{}'); } catch (e) { return {}; } })();

    const money = (value) => `${Number(value).toLocaleString('fr-FR')} ${currency}`;
    const getStoredPromo = () => {
      try { return localStorage.getItem('anya_referral_code') || ''; } catch (e) { return ''; }
    };
    const storePromo = (value) => {
      try {
        if (value) localStorage.setItem('anya_referral_code', value);
        else localStorage.removeItem('anya_referral_code');
      } catch (e) {}
    };
    const updateShippingSummary = () => {
      const welcome = window.AnyaWelcome.calculate(selectedPrice);
      builder.querySelectorAll('[data-welcome-label], [data-welcome-amount]').forEach(el => { el.hidden = welcome.discount <= 0; });
      const welcomeAmount = builder.querySelector('[data-welcome-amount]');
      if (welcomeAmount) welcomeAmount.textContent = '− ' + money(welcome.discount);
      if (shippingEl) shippingEl.textContent = shippingRate ? money(shippingRate.price) : (PT.shipping_pending || 'Choisissez une ville');
      if (totalPrice) totalPrice.textContent = shippingRate ? money(Math.round((welcome.net + shippingRate.price) * 100) / 100) : (PT.shipping_pending || 'Choisissez une ville');
    };

    const createSelector = (label, index, isFree, format) => {
      const wrapper = document.createElement('div');
      wrapper.className = 'anya-scent-field';

      const labelElement = document.createElement('label');
      const selectId = `${builder.id || 'anya-packs'}-scent-${index}`;
      labelElement.htmlFor = selectId;
      labelElement.textContent = isFree ? `${label} — ${PT.free_suffix || 'offert'}` : label;

      const select = document.createElement('select');
      select.id = selectId;
      select.dataset.scentChoice = '';
      select.dataset.format = format || '50 g';

      scents.forEach((scent) => {
        const option = document.createElement('option');
        option.value = scent.name;
        option.textContent = scent.label;
        option.dataset.color = scent.color;
        if (scent.name === defaultScent) option.selected = true;
        select.appendChild(option);
      });

      wrapper.append(labelElement, select);
      return wrapper;
    };

    const renderOffer = (offer) => {
      selectedOffer = offer;
      offerButtons.forEach((button) => {
        const selected = button === offer;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', String(selected));
      });

      const grandSlots = Number(offer.dataset.grandSlots || 0);
      const miniSlots = Number(offer.dataset.miniSlots || 0);
      const freeMini = offer.dataset.freeMini === 'true';
      const price = Number(offer.dataset.price || 0);

      selectedOfferHeading.textContent = offer.dataset.offerName;
      productPrice.textContent = money(price);
      selectedPrice = price;
      updateShippingSummary();

      const refPrice = Number(offer.dataset.refPrice || price);
      const freeMiniValue = Number(offer.dataset.freeMiniValue || 0);
      const before = refPrice - freeMiniValue;
      const discount = Math.max(0, before - price);
      const hasDiscount = discount > 0;
      if (beforeLabel && beforeVal) { beforeLabel.hidden = beforeVal.hidden = !hasDiscount; beforeVal.textContent = money(before); }
      if (savingsRow && savingsEl) { savingsRow.hidden = savingsEl.hidden = !hasDiscount; savingsEl.textContent = `− ${money(discount)}`; }
      if (giftLabel && giftVal) { const hasGift = freeMiniValue > 0; giftLabel.hidden = giftVal.hidden = !hasGift; giftVal.textContent = money(freeMiniValue); }
      if (productsLabel && priceGrid) productsLabel.textContent = hasDiscount ? (priceGrid.dataset.labelAfter || productsLabel.textContent) : (priceGrid.dataset.labelProducts || productsLabel.textContent);

      selectorContainer.replaceChildren();

      for (let index = 1; index <= grandSlots; index += 1) {
        selectorContainer.appendChild(createSelector(`${PT.grand || 'Grand 50 g nº'} ${index}`, index, false, '50 g'));
      }
      for (let index = 1; index <= miniSlots; index += 1) {
        selectorContainer.appendChild(createSelector(`${PT.mini || 'Mini 15 g nº'} ${index}`, grandSlots + index, freeMini && index === miniSlots, '15 g'));
      }

      status.textContent = scents.length ? '' : (PT.no_scents || 'Aucun parfum disponible pour le moment.');
    };

    const revealComposer = () => {
      if (!composer || !window.matchMedia('(max-width: 899px)').matches) return;
      window.requestAnimationFrame(() => composer.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    };

    offerButtons.forEach((button) => button.addEventListener('click', () => {
      renderOffer(button);
      revealComposer();
    }));

    const productSticky = document.querySelector('[data-product-sticky]');
    if (productSticky && 'IntersectionObserver' in window) {
      const composerObserver = new IntersectionObserver(([entry]) => {
        productSticky.classList.toggle('is-hidden-for-composer', entry.isIntersecting);
      }, { threshold: 0.08 });
      composerObserver.observe(builder);
    }

    window.addEventListener('anya:select-pack', (event) => {
      const detail = event.detail || {};
      const requestedOffer = detail.offerId
        ? offerButtons.find((button) => button.dataset.offerId === detail.offerId)
        : null;
      renderOffer(requestedOffer || selectedOffer);

      if (detail.scent && scents.some((scent) => scent.name === detail.scent)) {
        selectorContainer.querySelectorAll('[data-scent-choice]').forEach((select) => {
          select.value = detail.scent;
        });
      }
      if (detail.city && cityInput) {
        cityInput.value = detail.city;
        cityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      if (detail.promo && promoInput) {
        promoInput.value = detail.promo;
        promoInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
      status.textContent = requestedOffer
        ? `${requestedOffer.dataset.offerName}${PT.selected_suffix || ' sélectionné. Choisissez chaque parfum puis confirmez sur WhatsApp.'}`
        : (PT.status_choose || 'Choisissez l’offre qui vous convient, puis personnalisez chaque parfum.');
      revealComposer();
    });

    window.AnyaShippingRates?.attach(cityInput, (match) => {
      shippingRate = match;
      if (match) {
        cityInput.value = match.city;
        cityInput.removeAttribute('aria-invalid');
        status.textContent = '';
      }
      updateShippingSummary();
    }, currency, {
      rate: PT.shipping_rate_label,
      delay: PT.shipping_delay_label,
      hint: PT.city_search_hint,
      empty: PT.city_no_results,
    });

    if (promoInput) {
      promoInput.value = promoInput.value || getStoredPromo();
      if (promoInput.value) promoInput.closest('details').open = true;
      promoInput.addEventListener('input', () => storePromo(promoInput.value.trim()));
    }

    window.addEventListener('anya:welcome-change', updateShippingSummary);
    submitButton.addEventListener('click', () => {
      const phone = (builder.dataset.whatsappNumber || '').replace(/\D/g, '');
      if (!phone) {
        status.textContent = PT.no_phone || 'Le numéro WhatsApp doit être renseigné dans les réglages du thème.';
        return;
      }

      const choices = [...selectorContainer.querySelectorAll('[data-scent-choice]')];
      if (!choices.length) {
        status.textContent = PT.no_scents_offer || 'Cette offre ne contient encore aucun parfum disponible.';
        return;
      }

      const price = Number(selectedOffer.dataset.price || 0);
      const city = String(cityInput?.value || '').trim();
      const delivery = window.AnyaShippingRates?.lookup(city);
      if (!delivery) {
        cityInput?.setAttribute('aria-invalid', 'true');
        status.textContent = PT.city_required || 'Choisissez une ville proposée dans la liste pour calculer la livraison.';
        cityInput?.focus();
        return;
      }
      const welcome = window.AnyaWelcome.calculate(price);
      const refPrice = Number(selectedOffer.dataset.refPrice || price);
      const savings = Math.max(0, refPrice - price);
      const promo = String(promoInput?.value || getStoredPromo()).trim();
      const selectionLines = choices.map(
        (select, index) => `${index + 1}. ${select.dataset.format === '15 g' ? W.size_15 : W.size_50} — ${(select.selectedOptions[0]?.textContent || select.value || '').trim()}`,
      );
      const message = [
        W.greeting,
        '',
        W.intent,
        `${W.offer} : ${selectedOffer.dataset.offerName}`,
        ...selectionLines,
        `${W.city} : ${delivery.city}`,
        '',
        `${W.products} : ${money(price)}`,
        ...(savings > 0 ? [`${PT.economy || 'Économie'} : ${money(savings)}`] : []),
        ...window.AnyaWelcome.lines(price, currency),
        `${W.shipping} : ${money(delivery.price)}`,
        `${window.AnyaWelcome.totalLabel} : ${money(Math.round((welcome.net + delivery.price) * 100) / 100)}`,
        ...(promo ? [`${PT.promo_message_label || W.promo || 'Code promo / parrainage'} : ${promo}`, PT.promo_message_note || 'À vérifier et appliquer par un agent ANYA. avant la confirmation.'] : []),
        '',
        W.confirm,
      ].join('\n');

      status.textContent = '';
      window.open(`https://wa.me/${phone}?text=${encodeURIComponent(message)}`, '_blank', 'noopener,noreferrer');

    });

    renderOffer(selectedOffer);
  });
})();
